export default __webpack_public_path__ + "static/media/loading.8a82d174.svg";